@if (viewModel && viewModel.productCode) {
  <rt-button
    #dropdownTrigger="rtOverlayOrigin"
    [dropdownOpened]="dropdown.open"
    (click)="dropdown.open = true"
    rt-overlay-origin
    variant="outline"
    [size]="size"
  >
    @if (viewModel.limitIndicator) {
      <rt-icon
        name="warning"
        [colorToken]="limitIndicatorTokenRecord[viewModel.limitIndicator]"
      ></rt-icon>
    }
    @if (viewModel.isUnlimited) {
      {{ 'app.pricing.billing_page.unlimited_slots' | translate }}
    }
    @if (!viewModel.isUnlimited) {
      {{ viewModel.slotsAvailable }}
      {{
        'app.pricing.slots_counter.slots_left_count'
          | translate: { count: viewModel.slotsAvailable }
      }}
    }
  </rt-button>
  <ng-template
    #dropdown="rtConnectedOverlay"
    [origin]="dropdownTrigger"
    (backdropClick)="dropdown.open = false"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown margin-top-small-x (click)="$event.preventDefault()">
      <div layout-vertical>
        <div layout-vertical padding-small>
          <rt-heading>
            {{ 'app.pricing.slots_counter.current_plan' | translate }}
          </rt-heading>
          <div layout-centered-y>
            <span text-dark>{{ viewModel.productCode | titlecase }}</span>
            @if (viewModel.trial) {
              <rt-badge
                [color]="viewModel.isPP24 ? 'grow' : 'scale-reverse'"
                [text]="'app.pricing.plan_picker.trial_plan' | translate"
                margin-left-small-x
              >
              </rt-badge>
            }
          </div>
        </div>
        <rt-divider></rt-divider>
        <div layout-vertical padding-small>
          <rt-heading>
            {{
              'app.pricing.slots_counter.job_slots_count'
                | translate: { count: viewModel.slotsTotal }
            }}
          </rt-heading>
          @if (viewModel.isUnlimited) {
            <span text-dark>
              {{ 'app.pricing.billing_page.unlimited' | translate }}
            </span>
          }
          @if (!viewModel.isUnlimited) {
            <span text-dark>
              {{ viewModel.slotsTotal }}
              {{
                'app.pricing.slots_counter.slots_count' | translate: { count: viewModel.slotsTotal }
              }}
              <span margin-lr-small-xx>•</span>
              {{ viewModel.slotsUsed }} {{ 'app.pricing.slots_counter.in_use' | translate }},
              {{ viewModel.slotsAvailable }} {{ 'app.pricing.slots_counter.available' | translate }}
            </span>
          }
        </div>
        @if (footerButtonTpl) {
          <rt-divider></rt-divider>
          <div layout padding-small>
            <ng-container *ngTemplateOutlet="footerButtonTpl"></ng-container>
          </div>
        }
      </div>
    </rt-dropdown>
  </ng-template>
}

<ng-template #intercomBtnTpl>
  <rt-button (click)="intercomService.open()" variant="primary">
    {{ 'app.common.get_in_touch' | translate }}
  </rt-button>
</ng-template>

<ng-template #updatePlanBtnTpl>
  <rt-button (click)="upgrade()" variant="primary">
    {{ 'app.pricing.slots_counter.upgrade_plan' | translate }}
  </rt-button>
</ng-template>

<ng-template #updateSlotsBtnTpl>
  <rt-button (click)="update()" variant="primary">
    {{ 'app.pricing.slots_counter.update_slots' | translate }}
  </rt-button>
</ng-template>
